import * as React from 'react';

import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { langDir } from 'js/lib/language';

import { ClientSideEmotionCacheProvider } from '@coursera/cds-core';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import type { Stores } from 'bundles/premium-certificate/appEnv';

import _t from 'i18n!nls/premium-certificate';

import 'css!bundles/premium-certificate/__styles__/index';

type Props = {
  requestCountryCode?: string | null;
  csrfToken?: string | null;
};

const PremiumCertificateApp = ({ children }: React.PropsWithChildren<Props>) => (
  <ClientSideEmotionCacheProvider direction={langDir(_t.getLocale())}>
    <div data-test="PremiumCertificateApp">
      <DefaultHeader isPositionStatic />
      <UniversalPageFeatures />
      {children}
      <PageFooter />
    </div>
  </ClientSideEmotionCacheProvider>
);

export default connectToStores<Props, {}, Stores>(['ApplicationStore'], ({ ApplicationStore }, props) => ({
  ...props,
  csrfToken: ApplicationStore.getState().csrfToken,
  requestCountryCode: ApplicationStore.getState().requestCountryCode,
}))(PremiumCertificateApp);
